import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FXBackdrop from "../components/FXBackdrop";

export default function NotFound() {
    return (
        <FXBackdrop>
            <section className="containerX pt-24 pb-16 text-center">
                <div className="text-7xl font-bold" style={{ background: "linear-gradient(135deg, rgba(139,92,246,1), rgba(168,85,247,1))", WebkitBackgroundClip: "text", color: "transparent" }}>
                    404
                </div>
                <h1 className="h1 mt-4 text-2xl">Page not found</h1>
                <p className="p mt-2">The page you're looking for doesn't exist or has been moved.</p>
                <div className="mt-6">
                    <NavLink to="/" className="btn btnPrimary px-7">Back to home <ArrowRight size={16} /></NavLink>
                </div>
            </section>
        </FXBackdrop>
    );
}
